import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location, formatDate } from '@angular/common';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { MerchantService,MerchantFilter } from '../../merchants/merchant-master/merchant.service';
import { Router } from '@angular/router';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { StorageService } from 'src/app/_services/storage.service';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { environment } from 'src/environments/environment';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { TransactionMasterService } from '../../fraud-prevention/transaction-master-rule/transaction-master-service';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { PiiDecryptService } from 'src/app/_services/pii-decrypt.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';
import { CustomerService } from '../../customers/customer-service';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

const {defaultCurrency, defaultPageSizeArr, defaultPageSize} = environment;

export interface CustomerFilter {
  "columns"?: any;
  "name"?: string,
  "mid"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "sendDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "rid"?:string,
  "status"?:string,
  "orderId"?:string,
  "transactionType"?:string,
  "dateFrom"?:string,
  "dateTo"?:string,
  "customerMobile"?:string,
  "totalAmount"?:string
  "Status"?:string,
  "user_type"?:string,

  "txnId"?:string,
  "walletId"?:string,
  "currency"?:string,
  "productCode"?:string,
  "merchantName"?:string,
  "merchant"?:string,
  "merchantId"?:string
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

@Component({
  selector: 'app-customer-remittance-report',
  templateUrl: './customer-remittance-report.component.html',
  styleUrls: ['./customer-remittance-report.component.scss']
})
export class CustomerRemittanceReportComponent implements OnInit {

  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public pageNumber :any = 0;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;  
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: any[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   merchantStatusdata: any;
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   modalConfigReport: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   customerMobile :any;
   transactionType : any;
   status :any;
   orderId : any;
   dateFrom :NgbDateStruct;
   dateTo : NgbDateStruct;
   minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  sort : any = "DESC";
  columnName : any = "createDate";
  
  customerEmail: string = '';
  customerPhone: string = '';
  currency: any;
  paymentMethod: string = 'ALL';
  mopType: string = 'ALL';
  statusList: any = [];
  customerData:any=[];
  merchant:any;
  pOrderId: string = '';
  txnId: string = '';
  walletId:  string = '';
  productCode: string = 'CROSS_BORDER_TRANSFER';
  txnStatus:string='';
  merchantId:string='';
  merchantName:string='';

  columnnName:string="";
  logicalCondition:any;
  searchText:any;
  columnnName1:string="";
  logicalCondition1:any;
  searchText1:any;
  columnnName2:string="";
  logicalCondition2:any;
  searchText2:any;
   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 180,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filTransactionType') private filTransactionType: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;

  public columnDefs: ColDef[] = [
    { field: 'senderUserId', sortable: false, lockVisible: true, headerName: 'Sender ID', resizable: true },
    { field: 'userMobile', sortable: false, lockVisible: true, headerName: 'Sender Mobile' },
    { field: 'senderName', sortable: false, lockVisible: true, headerName: 'Sender Name' },
    { field: 'receiverId', sortable: false, lockVisible: true, headerName: 'Receiver ID' },
    { field: 'walletSenderId', sortable: false, lockVisible: true, headerName: 'Sender Wallet ID' },
    // { field: 'walletReceiverId', sortable: false, lockVisible: true, headerName: 'Receiver Wallet ID' },
    // { field: 'merchantIdentifierId', sortable: false, lockVisible: true, headerName: 'Merchant ID' },
    // { field: 'resellerId', sortable: false, lockVisible: true, headerName: 'Reseller ID' },
    { field: 'originalTxnId',  headerName: 'Original TRXN ID',lockVisible:true, },
    { field: 'receiverMobile', sortable: false, lockVisible: true, headerName: 'Receiver Mobile' },
    { field: 'receiverName', sortable: false, lockVisible: true, headerName: 'Receiver Name' },
    { field: 'receiverType', sortable: false, lockVisible: true, headerName: 'Receiver Type' },
    { field: 'txnId', sortable: false, lockVisible: true, headerName: 'Transaction ID' },
    { field: 'transactionType', sortable: false, lockVisible: true, headerName: 'Credit / Debit' },
    // { field: 'merchantReferenceId', sortable: false, lockVisible: true, headerName: 'Order ID' },
    { field: 'sendingCurrency', sortable: false, lockVisible: true, headerName: 'Send Currency' },
    { field: 'senderVAIBAN', sortable: false, lockVisible: true, headerName: 'Sender VA IBAN',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    // { field: 'receiverVAIBAN', sortable: false, lockVisible: true, headerName: 'Receiver VA IBAN',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    { field: 'currency', sortable: false, lockVisible: true, headerName: 'Receive Currency' },
    { field: 'exchangeRate', sortable: false, lockVisible: true, headerName: 'FX Rate' },
    { field: 'amount', sortable: false, lockVisible: true, headerName: 'Amount' },
    { field: 'totalAmount', sortable: false, lockVisible: true, headerName: 'Total Amount' },
    // { field: 'transactionStatus', sortable: false, lockVisible: true, headerName: 'Transaction Status' },
    { field: 'serviceCharges', sortable: false, lockVisible: true, headerName: 'Service Charges' },
    { field: 'vat', sortable: false, lockVisible: true, headerName: 'VAT' },
    { field: 'status', sortable: false, lockVisible: true, headerName: 'Status' },
    // { field: 'status', sortable: false, lockVisible: true, headerName: 'Shield Status' },
    { field: 'responseMessage', sortable: false, lockVisible: true, headerName: 'Shield Message' },
    { field: 'responseCode', sortable: false, lockVisible: true, headerName: 'Shield Code' },
    { field: 'serviceProviderResponseCode', sortable: false, lockVisible: true, headerName: 'SP Status' },
    { field: 'serviceProviderResponseMessage', sortable: false, lockVisible: true, headerName: 'SP Message' },
    { field: 'serviceProviderTxnId', sortable: false, lockVisible: true, headerName: 'SP Trxn ID' },
    // { field: 'serviceProviderRrn', sortable: false, lockVisible: true, headerName: 'SP RRN' },
    { field: 'dateTime', sortable: false, lockVisible: true, headerName: 'Trxn Initiated Date Time' },
    { field: 'updateDateTime', sortable: false, lockVisible: true, headerName: 'Updated Trxn Date Time' },
    { field: 'ipAddress', sortable: false, lockVisible: true, headerName: 'IP Address'},
    { field: 'gps', sortable: false, lockVisible: true, headerName: 'GPS Coordinates' },
    // { field: 'osType', sortable: false, lockVisible: true, headerName: 'OS Type' },
    { field: 'osVersion', sortable: false, lockVisible: true, headerName: 'OS Version' },
    { field: 'deviceModel', sortable: false, lockVisible: true, headerName: 'Device Model' },
    { field: 'deviceId', sortable: false, lockVisible: true, headerName: 'Device ID' },
    { field: 'appVersion', sortable: false, lockVisible: true, headerName: 'App Version' },
    { field: 'typeOfTransaction', sortable: false, lockVisible: true, headerName: 'Transaction Type' },
    { field: 'productCode', sortable: false, lockVisible: true, headerName: 'Product Code' },
    { field: 'channel', sortable: false, lockVisible: true, headerName: 'Channel' },
    { field: 'category', sortable: false, lockVisible: true, headerName: 'Category' },
    { field: 'mode', sortable: false, lockVisible: true, headerName: 'Mode' },
    { field: 'region', sortable: false, lockVisible: true, headerName: 'Region'},
    { field: 'instantCapture', sortable: false, lockVisible: true, headerName: 'Instant Captured' },
    { field: 'referenceId', sortable: false, lockVisible: true, headerName: 'Pay10 Reference ID' },
    { field: 'rrn', sortable: false, lockVisible: true, headerName: 'Bank Reference Number'},
    // { field: 'vamReferenceNumber', sortable: false, lockVisible: true, headerName: 'VAM Reference Number'},
    // { field: '', sortable: false, lockVisible: true, headerName: 'Outlet ID' },
    // { field: 'merchantTerminalId', sortable: false, lockVisible: true, headerName: 'Terminal ID' },
    // { field: '', sortable: false, lockVisible: true, headerName: '3DS' },
    // { field: '', sortable: false, lockVisible: true, headerName: 'Card Number',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    // { field: '', sortable: false, lockVisible: true, headerName: 'Commission',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    { field: '', sortable: false, lockVisible: true, headerName: 'Discounts/Promo' },
    // { field: '', sortable: false, lockVisible: true, headerName: 'Auth Code',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
    {
      field: 'unmasking', 
      headerName: 'Unmasking',
      lockVisible: true, 
      width: 120, 
      cellRenderer: BtnCellRenderer1, 
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            // Toggle PII unmask for the entire row
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true,
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
    }
  ];
  

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  
  constructor(private menuService: MenusService,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,
    private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter,private transactionService : TransactionMasterService,private customerService : CustomerService,private piiDecryptService: PiiDecryptService, private piiGridService: PiiGridService, private exportTrackingService: ExportTrackingService) {

    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    //this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    
    // Add global debugging methods for BigDecimal testing
    (window as any).testBigDecimalDecryption = this.testBigDecimalDecryption.bind(this);
    (window as any).debugTransactionAmounts = this.debugTransactionAmounts.bind(this);
    (window as any).checkAmountFields = this.checkAmountFields.bind(this);
    // Add global debugging methods for unified encryption testing (DEVELOPMENT ONLY)
    if (!environment.production) {
      (window as any).testUnifiedDecryption = this.testUnifiedDecryption.bind(this);
      (window as any).debugAllEncryptedFields = this.debugAllEncryptedFields.bind(this);
      (window as any).checkSpecificAmountFields = this.checkSpecificAmountFields.bind(this);
      (window as any).testSpecificEncryptedAmounts = this.testSpecificEncryptedAmounts.bind(this);
      console.log('🔧 PII Debugging methods available in development mode');
    }
  }
  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    // this.searchFromDate= this.ngbCalender.getToday();
    // this.searchToDate= this.ngbCalender.getToday();
    this.merchnatList();
    this.customerList();
    this.currencyList();

  }

  merchnatList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.merchantService.getMerchantList("","","","","","","",filter,"ALL",0).subscribe((response)=>{
      console.log(response);
      this.Resultdata = response.content;
    })
  }
  customerList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.customerService.getCustomerDropDown().subscribe((response:any)=>{
      console.log(response);
     this.customerData = response.content;
    })
  }

  currencyrData:any=[];
  currencyList() {
    this.customerService.getCurrencyList().subscribe((response:any)=>{
      console.log(response);
      this.currencyrData = response.response.data;
      console.log(this.currencyrData);
      this.currencyrData  = [...new Set(this.currencyrData.map((item:any) => item.currencyCode))];
      console.log(this.currencyrData);
    })
  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

  merchantStatusDropdown() {
    return this.merchantService.getMerchantStatus()
        // .post(
        //   `${API_URL}/GetDropdown`, postdata
        // )
        .subscribe((res) => (this.merchantStatusdata = res,console.log("res",this.merchantStatusdata)));
  
    }



  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58);

  }


  onExportCSV() {
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Customer_Transaction_Report' + "_" + referenceId;
    this.onSearchPayments();
        const expData: any[] = [];
        (this.rowData).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
    //  })




  }

  onBackgroundExport() {
    const filter: CustomerFilter = {}
   
      // Validation for Column Name 1
  if (this.columnnName && !this.logicalCondition) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 1
  if (this.logicalCondition && !this.searchText) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 2
  if (this.columnnName1 && !this.logicalCondition1) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 2
  if (this.logicalCondition1 && !this.searchText1) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 3
  if (this.columnnName2 && !this.logicalCondition2) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 3
  if (this.logicalCondition2 && !this.searchText2) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }
   // console.log("Date From : "+this.dateFrom+"00:00:00");
 // console.log("Date To : "+this.dateTo+"59:59:59");


    // console.log("new");

    console.log("Transaction Id:", this.txnId);
    // console.log("Customer Mobile :"+this.customerMobile);
    console.log("Wallet ID:", this.walletId);
    console.log("Currency:", this.currency);
    console.log("Product Code:", this.productCode);
    console.log("Merchant Name:", this.merchantName);
    console.log("Merchant:", this.merchant);
    console.log("Merchant ID:", this.merchantId);
    console.log("Search From Date:", this.searchFromDate);
    console.log("Search To Date:", this.searchToDate);
    console.log("Column Name:", this.columnnName);
    console.log("Logical Condition:", this.logicalCondition);
    console.log("Search Text:", this.searchText);
    console.log("Column Name 1:", this.columnnName1);
    console.log("Logical Condition 1:", this.logicalCondition1);
    console.log("Search Text 1:", this.searchText1);
    console.log("Column Name 2:", this.columnnName2);
    console.log("Logical Condition 2:", this.logicalCondition2);
    console.log("Search Text 2:", this.searchText2);

    if(this.customerMobile != undefined){
      filter.customerMobile = this.customerMobile;
    }
    else{
      filter.customerMobile = "";
    }

    if(this.transactionType != undefined){
      console.log("Data ");
      filter.transactionType = this.transactionType;
    }else{
      filter.transactionType = "ALL";
    }

    if(this.status != undefined){
      filter.status = this.status;
    }else{
      filter.status = "ALL";
    }

    if(this.orderId != undefined){
      filter.orderId = this.orderId;
    }

    if(this.txnId != undefined){
      filter.txnId = this.txnId;
    }

    if(this.walletId != undefined){
      filter.walletId = this.walletId;
    }

    if(this.productCode != undefined){
      filter.productCode = this.productCode;
    }

    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00" || 
       !this.searchFromDate || 
       Object.keys(this.searchFromDate).length === 0){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== "" || 
       !this.searchToDate || 
       Object.keys(this.searchToDate).length === 0){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    console.log("1.txnId: ", this.txnId);
    console.log("1.walletId: ", this.walletId);
    console.log("1.productCode: ", this.productCode);

    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    if(this.txnId == undefined){
      this.txnId = "";
    }
    if(this.walletId == undefined){
      this.walletId = "";
    }

    filter.txnId = this.txnId ?? "";
    filter.walletId = this.walletId ?? "";
    filter.currency = this.currency ?? "";
    filter.productCode = this.productCode;
    filter.merchantName = this.merchantName ?? "";
    filter.merchant = this.merchant ?? "";
    filter.merchantId = this.merchantId ?? "";
    
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    this.transactionService.getTransactionReportBackgroundExport(
      filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3
    ).subscribe(
      (response: any) => {
        this.loading = false;
        console.log('Background export response:', response);
        
        if (response?.response?.status === 200) {
          const referenceId = response.response.data[" document referenceId"] || response.response.data.documentReferenceId;
          const recordsCount = response.response.data.recordsCount;
          
          this.alertService.successAlertWithAcknowledgment(
            `Your export of ${recordsCount} records has started. Reference ID: ${referenceId}`
          );
        } else if (response?.response?.status === 509) {
          this.alertService.errorAlertWithMessage(
            `Export limit exceeded: ${response.response.data.message}`
          );
        } else {
          this.alertService.errorAlertWithMessage(
            response?.response?.message || "An error occurred during export. Please try again later."
          );
        }
      },
      error => {
        this.loading = false;
        console.error('Background export error:', error);
        
        this.alertService.errorAlertWithMessage(
          error?.response?.message || "Failed to start background export. Please try again later."
        );
      }
    );
  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'CUSTOMER_TRANSACTION_REPORT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Customer transaction export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      merchantName: this.searchMerName || '',
      merchantId: this.searchMID || '',
      walletId: this.walletId || '',
      customerMobile: this.customerMobile || '',
      status: this.status || '',
      transactionType: this.transactionType || '',
      dateFrom: this.searchFromDate ? `${this.searchFromDate.year}-${this.searchFromDate.month}-${this.searchFromDate.day}` : '',
      dateTo: this.searchToDate ? `${this.searchToDate.year}-${this.searchToDate.month}-${this.searchToDate.day}` : '',
      orderId: this.orderId || '',
      resellerPartnerId: this.resellerPartnerId || '',
      productCode: this.productCode || '',
      txnId: this.txnId || ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  onSearchFilter(){
    this.pageNumber = 0;
    this.onSearchPayments();
  }

  onSearchPayments(){
    const filter: CustomerFilter = {}
   
      // Validation for Column Name 1
  if (this.columnnName && !this.logicalCondition) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 1
  if (this.logicalCondition && !this.searchText) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 2
  if (this.columnnName1 && !this.logicalCondition1) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 2
  if (this.logicalCondition1 && !this.searchText1) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }

  // Validation for Column Name 3
  if (this.columnnName2 && !this.logicalCondition2) {
    this.alertService.errorAlertWithMessage("Please select a logical condition.");
    return;
  }

  // Validation for Logical Condition 3
  if (this.logicalCondition2 && !this.searchText2) {
    this.alertService.errorAlertWithMessage("Please enter a search text.");
    return;
  }
   // console.log("Date From : "+this.dateFrom+"00:00:00");
 // console.log("Date To : "+this.dateTo+"59:59:59");


    // console.log("new");

    console.log("Transaction Id:", this.txnId);
    // console.log("Customer Mobile :"+this.customerMobile);
    console.log("Wallet ID:", this.walletId);
    console.log("Currency:", this.currency);
    console.log("Product Code:", this.productCode);
    console.log("Merchant Name:", this.merchantName);
    console.log("Merchant:", this.merchant);
    console.log("Merchant ID:", this.merchantId);
    console.log("Search From Date:", this.searchFromDate);
    console.log("Search To Date:", this.searchToDate);
    console.log("Column Name:", this.columnnName);
    console.log("Logical Condition:", this.logicalCondition);
    console.log("Search Text:", this.searchText);
    console.log("Column Name 1:", this.columnnName1);
    console.log("Logical Condition 1:", this.logicalCondition1);
    console.log("Search Text 1:", this.searchText1);
    console.log("Column Name 2:", this.columnnName2);
    console.log("Logical Condition 2:", this.logicalCondition2);
    console.log("Search Text 2:", this.searchText2);

    if(this.customerMobile != undefined){
      filter.customerMobile = this.customerMobile;
    }
    else{
      filter.customerMobile = "";
    }

    if(this.transactionType != undefined){
      console.log("Data ");
      filter.transactionType = this.transactionType;
    }else{
      filter.transactionType = "ALL";
    }

    if(this.status != undefined){
      filter.status = this.status;
    }else{
      filter.status = "ALL";
    }

    if(this.orderId != undefined){
      filter.orderId = this.orderId;
    }

    if(this.txnId != undefined){
      filter.txnId = this.txnId;
    }

    if(this.walletId != undefined){
      filter.walletId = this.walletId;
    }

    if(this.productCode != undefined){
      filter.productCode = this.productCode;
    }

    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00" || 
       !this.searchFromDate || 
       Object.keys(this.searchFromDate).length === 0){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== "" || 
       !this.searchToDate || 
       Object.keys(this.searchToDate).length === 0){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    console.log("2. txnId: ", this.txnId);
    console.log("2. walletId: ", this.walletId);

    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    if(this.txnId == undefined){
      this.txnId = "";
    }
    if(this.walletId == undefined){
      this.walletId = "";
    }

    filter.txnId = this.txnId ?? "";
    filter.walletId = this.walletId ?? "";
    filter.currency = this.currency ?? "";
    filter.productCode = this.productCode;
    filter.merchantName = this.merchantName ?? "";
    filter.merchant = this.merchant ?? "";
    filter.merchantId = this.merchantId ?? "";
    
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    return this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
    .subscribe((res:any) => {
      console.log(res);
      
      if(res.response.data.content.length<=0){
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
      const currentDate = new Date();
      const cValue = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');
      console.log(cValue);
      this.rowData = res.response.data.content;
      this.rowData.map((_: any) => {
        _.sendingCurrency = defaultCurrency;
        if(_.longitude != null && _.latitude != null ){
          _.gps =  _.longitude+" , "+_.latitude;
        }else{
          _.gps = '';
        }
        // Replace null values with 'N/A'
        Object.keys(_).forEach(key => {
          if (_[key] === null || _[key] === undefined || _[key] === '') {
            _[key] = 'N/A';
          }
        });
     })
      this.collectiondata = res.response.data.content
      this.collectionSize= res.response.data.totalElements
      this.totalRecords =  res.response.data.totalElements
    })
  }

  onSearchBtnClick($event: Event) {
    const filter: CustomerFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else{
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
     if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType
    
      if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    // if (this.Status) filter.Status=this.Status||'';
    if(this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00"){
      if (this.searchFromDate) filter.startDate = "";

    }else{
      if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
    if(this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00"){
      if (this.searchToDate) filter.endDate = "";

    }else{
      if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    console.log("3. txnId: ", this.txnId);
    console.log("3. walletId: ", this.walletId);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    if(this.txnId == undefined){
      this.txnId = "";
    }
    if(this.walletId == undefined){
      this.walletId = "";
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }

    return this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.sendingCurrency = defaultCurrency;
          if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
          // Replace null values with 'N/A'
          Object.keys(_).forEach(key => {
            if (_[key] === null || _[key] === undefined || _[key] === '') {
              _[key] = 'N/A';
            }
          });
       })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
        if(data.response.data.content.length<=0){
          console.log("No data");
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked" + param.data.registeredMobile);
    // return await this.router.navigate(['/customerEdit'], {

    //   queryParams: {
    //     mid: param?.data?.registeredMobile,
    //   }
    // })

  }
  
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    console.log(param);
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    this.pageNumber = (param -1)
    const filter: CustomerFilter = {}
    console.log("Customer Mobile :"+this.customerMobile);
    console.log("Date From : "+this.dateFrom+"00:00:00");
    console.log("Date To : "+this.dateTo+"59:59:59");
    console.log("Transaction Type : "+this.transactionType);
    console.log("Sstatus : "+this.status);
    console.log("Oder ID : "+this.orderId);
    this.onSearchPayments()
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    this.pageNumber = 0;
    this.onSearchPayments();

         
  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    const filter: CustomerFilter = {}
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    const currentDate = new Date();
    const cValue = formatDate(currentDate, 'yyyy-MM-dd', 'en-US');
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.ngbDateParserFormatter.format(this.searchFromDate));
    console.log(this.ngbDateParserFormatter.format(this.searchToDate));
    console.log("4. txnId: ", this.txnId);
    console.log("4. walletId: ", this.walletId);
    console.log("4. productCode: ", this.productCode);

    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    if(this.txnId == undefined){
      this.txnId = "";
    }
    if(this.walletId == undefined){
      this.walletId = "";
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }

    filter.productCode = this.productCode;

    return this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          console.log(_.longitude);
           _.sendingCurrency = defaultCurrency;
           if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
          // Replace null values with 'N/A'
          Object.keys(_).forEach(key => {
            if (_[key] === null || _[key] === undefined || _[key] === '') {
              _[key] = 'N/A';
            }
          });
        })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
        
      });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
    
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }
  changeDate(){
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate()
  {
    this.currentDate = this.searchToDate;
    this.maxDateFrom=this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){    
    const filter: CustomerFilter = {}
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
    if(listOfSortModel != null){
      if(listOfSortModel.length != 0){
        if(listOfSortModel[0].sort == "asc"){
          this.sort = "ASC";
        }else{
          this.sort = "DESC";
        }
        
        console.log(listOfSortModel[0].colId);
        this.columnName = listOfSortModel[0].colId;
        if(this.customerMobile == undefined){
          this.customerMobile = "";
        }
        if(this.transactionType == undefined){
          this.transactionType = null;
        }
        if(this.status == undefined){
          this.status = null;
        }
        if(this.txnId == undefined){
          this.txnId = "";
        }
        if(this.walletId == undefined){
          this.walletId = "";
        }
        
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00" || 
       !this.searchFromDate || 
       Object.keys(this.searchFromDate).length === 0){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== "" || 
       !this.searchToDate || 
       Object.keys(this.searchToDate).length === 0){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }   
    
        let column1:any={
          columnnName:this.columnnName ?? "",
          logicalCondition:this.logicalCondition ?? "",
          searchText:this.searchText ?? "",
        }
        let column2:any={
          columnnName:this.columnnName1 ?? "",
          logicalCondition:this.logicalCondition1 ?? "",
          searchText:this.searchText1 ?? "",
        }
        let column3:any={
          columnnName:this.columnnName2 ?? "",
          logicalCondition:this.logicalCondition2 ?? "",
          searchText:this.searchText2 ?? "",
        }
    
        this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
          .subscribe((data:any) => {
            console.log(data);
            this.rowData = data.response.data.content;
            this.rowData.map((_: any) => {
              _.sendingCurrency = defaultCurrency;
              if(_.longitude != null && _.latitude != null ){
                _.gps =  _.longitude+" , "+_.latitude;
              }else{
                _.gps = '';
              }
              // Replace null values with 'N/A'
              Object.keys(_).forEach(key => {
                if (_[key] === null || _[key] === undefined || _[key] === '') {
                  _[key] = 'N/A';
                }
              });
           })
            this.collectiondata = data.response.data.content
            this.collectionSize= data.response.data.totalElements
            this.totalRecords =  data.response.data.totalElements
          });

      }else{
        this.columnName = "";
        this.sort = "";
        if(this.customerMobile == undefined){
          this.customerMobile = "";
        }
        if(this.transactionType == undefined){
          this.transactionType = null;
        }
        if(this.status == undefined){
          this.status = null;
        }
        if(this.txnId == undefined){
          this.txnId = "";
        }
        if(this.walletId == undefined){
          this.walletId = "";
        }
        let column1:any={
          columnnName:this.columnnName ?? "",
          logicalCondition:this.logicalCondition ?? "",
          searchText:this.searchText ?? "",
        }
        let column2:any={
          columnnName:this.columnnName1 ?? "",
          logicalCondition:this.logicalCondition1 ?? "",
          searchText:this.searchText1 ?? "",
        }
        let column3:any={
          columnnName:this.columnnName2 ?? "",
          logicalCondition:this.logicalCondition2 ?? "",
          searchText:this.searchText2 ?? "",
        }
        this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
          .subscribe((data:any) => {
            console.log(data);
            this.rowData = data.response.data.content;
            this.rowData.map((_: any) => {
              _.sendingCurrency = defaultCurrency;
              if(_.longitude != null && _.latitude != null ){
                _.gps =  _.longitude+" , "+_.latitude;
              }else{
                _.gps = '';
              }
              // Replace null values with 'N/A'
              Object.keys(_).forEach(key => {
                if (_[key] === null || _[key] === undefined || _[key] === '') {
                  _[key] = 'N/A';
                }
              });
           })
            this.collectiondata = data.response.data.content
            this.collectionSize= data.response.data.totalElements
            this.totalRecords =  data.response.data.totalElements
          });
      }
    }
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    console.log(this.customerMobile);
    console.log(this.transactionType);
    console.log(this.status);
    console.log(this.searchFromDate);
    console.log(this.searchToDate);
    if(this.customerMobile == undefined){
      this.customerMobile = "";
    }
    if(this.transactionType == undefined){
      this.transactionType = null;
    }
    if(this.status == undefined){
      this.status = null;
    }
    if(this.txnId == undefined){
      this.txnId = "";
    }
    if(this.walletId == undefined){
      this.walletId = "";
    }
    let column1:any={
      columnnName:this.columnnName ?? "",
      logicalCondition:this.logicalCondition ?? "",
      searchText:this.searchText ?? "",
    }
    let column2:any={
      columnnName:this.columnnName1 ?? "",
      logicalCondition:this.logicalCondition1 ?? "",
      searchText:this.searchText1 ?? "",
    }
    let column3:any={
      columnnName:this.columnnName2 ?? "",
      logicalCondition:this.logicalCondition2 ?? "",
      searchText:this.searchText2 ?? "",
    }
    return this.transactionService.getTransactionReportListAll(filter,this.customerMobile,this.transactionType,this.status,"","",this.pageSize,this.pageNumber,this.sort,this.columnName,column1,column2,column3)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.response.data.content;
        this.rowData.map((_: any) => {
          _.sendingCurrency = defaultCurrency;
          if(_.longitude != null && _.latitude != null ){
            _.gps =  _.longitude+" , "+_.latitude;
          }else{
            _.gps = '';
          }
          // Replace null values with 'N/A'
          Object.keys(_).forEach(key => {
            if (_[key] === null || _[key] === undefined || _[key] === '') {
              _[key] = 'N/A';
            }
          });
       })
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
      });
        
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  resetFilter() {
    this.searchFromDate = { year: 0, month: 0, day: 0 };
    this.searchToDate = { year: 0, month: 0, day: 0 };
    this.txnId = "";
    this.customerMobile = "";
    this.walletId = "";

    this.currency = null;
    this.status = null;
    this.merchantName = "";
    this.merchant = null;
    this.merchantId = "";
    this.columnnName = "";
    this.logicalCondition = "";
    this.searchText = "";
    this.columnnName1 = "";
    this.logicalCondition1 = "";
    this.searchText1 = "";
    this.columnnName2 = "";
    this.logicalCondition2 = "";
    this.searchText2 = "";

    // Clear any additional form-specific handlers
    if (this.filStatus) this.filStatus.handleClearClick();
    if (this.filTransactionType) this.filTransactionType.handleClearClick();
    if (this.filResellerPartnerId) this.filResellerPartnerId.handleClearClick();
    this.onSearchPayments();
}


  onColumnNameChange() {
    if (!this.columnnName) {
      this.logicalCondition = '';
      this.searchText = '';
    }
  }

  onColumnNameChange1() {
    if (!this.columnnName1) {
      this.logicalCondition1 = '';
      this.searchText1 = '';
    }
  }

  onColumnNameChange2() {
    if (!this.columnnName2) {
      this.logicalCondition2 = '';
      this.searchText2 = '';
    }
  }

  getDisabledColumns(): string[] {
    return [this.columnnName, this.columnnName1, this.columnnName2];
  }

  // Add global debugging methods for BigDecimal testing
  testBigDecimalDecryption(value: any) {
    console.log('Testing BigDecimal decryption:', value);
    if (typeof value === 'string') {
      try {
        const decrypted = this.piiDecryptService.decrypt(value);
        console.log('Decrypted value:', decrypted);
      } catch (e) {
        console.error('Error decrypting value:', e);
      }
    } else {
      console.log('Value is not a string:', value);
    }
  }

  debugTransactionAmounts() {
    console.log('Debugging transaction amounts...');
    if (!this.rowData || this.rowData.length === 0) {
      console.log('No row data available');
      return;
    }
    
    console.log('Total rows:', this.rowData.length);
    
    // Check first few rows
    this.rowData.slice(0, 3).forEach((row: any, index: number) => {
      console.log(`=== Row ${index + 1} ===`);
      
      // Check amount fields
      ['amount', 'totalAmount', 'serviceCharges', 'vat'].forEach(field => {
        if (row.hasOwnProperty(field)) {
          const value = row[field];
          console.log(`${field}:`, {
            value: value,
            type: typeof value,
            isNumber: typeof value === 'number',
            isString: typeof value === 'string',
            isEmpty: value === null || value === undefined || value === ''
          });
        } else {
          console.log(`${field}: field not found in row`);
        }
      });
    });
  }

  checkAmountFields() {
    console.log('Checking amount fields for BigDecimal handling...');
    this.debugTransactionAmounts();
  }

   // Add debugging methods for unified encryption approach
   testUnifiedDecryption(encryptedValue: string) {
     console.log('🧪 Testing Unified Decryption:');
     console.log('Input:', encryptedValue);
     console.log('Is Encrypted:', this.piiDecryptService.isEncrypted(encryptedValue));
     
     if (this.piiDecryptService.isEncrypted(encryptedValue)) {
       const decrypted = this.piiDecryptService.decrypt(encryptedValue);
       console.log('Decrypted:', decrypted);
       console.log('Is Numeric:', this.isNumericString(decrypted));
       
       if (this.isNumericString(decrypted)) {
         console.log('💰 This is an encrypted amount!');
         console.log('As Number:', parseFloat(decrypted));
       }
     }
   }

   private isNumericString(str: string): boolean {
     if (!str || str.trim() === '') return false;
     const numericPattern = /^-?\d+(\.\d+)?$/;
     return numericPattern.test(str.trim());
   }

   debugAllEncryptedFields() {
     console.log('🔍 === Debugging All Encrypted Fields ===');
     if (!this.rowData || this.rowData.length === 0) {
       console.log('No data available');
       return;
     }

     // Check first row for all encrypted fields
     const firstRow = this.rowData[0];
     console.log('Analyzing first row...');
     
     Object.keys(firstRow).forEach(key => {
       const value = firstRow[key];
       if (typeof value === 'string' && value.length > 10) {
         const isEncrypted = this.piiDecryptService.isEncrypted(value);
         if (isEncrypted) {
           console.log(`🔐 Found encrypted field: ${key}`);
           const decrypted = this.piiDecryptService.decrypt(value);
           console.log(`  Encrypted: ${value.substring(0, 20)}...`);
           console.log(`  Decrypted: ${decrypted}`);
           console.log(`  Is Numeric: ${this.isNumericString(decrypted)}`);
           
           if (this.isNumericString(decrypted)) {
             console.log(`  💰 Amount Field: ${parseFloat(decrypted)}`);
           }
         }
       }
     });
   }

   checkSpecificAmountFields() {
     console.log('💰 === Checking Amount Fields ===');
     if (!this.rowData || this.rowData.length === 0) {
       console.log('No data available');
       return;
     }

     const amountFields = ['amount', 'totalAmount', 'vat', 'serviceCharges'];
     const firstRow = this.rowData[0];
     
     amountFields.forEach(field => {
       if (firstRow.hasOwnProperty(field)) {
         const value = firstRow[field];
         console.log(`Field: ${field}`);
         console.log(`  Value: ${value}`);
         console.log(`  Type: ${typeof value}`);
         
         if (typeof value === 'string') {
           console.log(`  Is Encrypted: ${this.piiDecryptService.isEncrypted(value)}`);
           if (this.piiDecryptService.isEncrypted(value)) {
             const decrypted = this.piiDecryptService.decrypt(value);
             console.log(`  Decrypted: ${decrypted}`);
             console.log(`  Is Amount: ${this.isNumericString(decrypted)}`);
           }
         }
       }
     });
   }

   // Test the specific encrypted values from the console
   testSpecificEncryptedAmounts() {
     console.log('🧪 === Testing Specific Encrypted Amounts ===');
     
     const encryptedAmounts = [
       'VFRdVlU=',  // amount field
       'UUpDVlVY',  // vat field  
       'U1ddVlU=',  // another amount
       'U1FdVlU=',  // another amount
       'VFFdU1A=',  // another amount
       'VEpKXw==',  // another amount
       'VEpLXg=='   // another amount
     ];
     
     encryptedAmounts.forEach(encrypted => {
       console.log(`Testing: ${encrypted}`);
       console.log(`  Is Encrypted: ${this.piiDecryptService.isEncrypted(encrypted)}`);
       
       if (this.piiDecryptService.isEncrypted(encrypted)) {
         const decrypted = this.piiDecryptService.decrypt(encrypted);
         console.log(`  Decrypted: ${decrypted}`);
         console.log(`  Is Numeric: ${this.isNumericString(decrypted)}`);
         
         if (this.isNumericString(decrypted)) {
           console.log(`  💰 Amount Value: ${parseFloat(decrypted)}`);
         }
       } else {
         console.log(`  ❌ Not detected as encrypted`);
       }
       console.log('---');
     });
   }
}
